import { useMachine } from '@xstate/react'
import { setup } from 'xstate'

// ---------------------------------------------------------------------------
// Events
// ---------------------------------------------------------------------------

type SpotDetailAttachedEvent =
  /** ARフォトボタンタップ時（スタンプ未取得）→ ロック表示を開く */
  | { type: 'OPEN_AR_PHOTO_LOCKED' }
  /** 音声ガイドボタンタップ → 音声ガイドダイアログを開く */
  | { type: 'OPEN_AUDIO_GUIDE' }
  /** 音声ガイドボタンタップ（有効範囲外）→ ロック表示を開く */
  | { type: 'OPEN_AUDIO_GUIDE_LOCKED' }
  /** ダイアログを閉じて idle へ戻る */
  | { type: 'CLOSE' }

// ---------------------------------------------------------------------------
// Machine
// ---------------------------------------------------------------------------

const spotDetailAttachedMachine = setup({
  types: { events: {} as SpotDetailAttachedEvent },
}).createMachine({
  id: 'spotDetailAttached',
  initial: 'idle',
  states: {
    idle: {
      on: {
        OPEN_AR_PHOTO_LOCKED: 'arPhotoLocked',
        OPEN_AUDIO_GUIDE: 'audioGuide',
        OPEN_AUDIO_GUIDE_LOCKED: 'audioGuideLocked',
      },
    },
    /** ARフォトフレームロック表示中 */
    arPhotoLocked: {
      on: { CLOSE: 'idle' },
    },
    /** 音声ガイドダイアログ表示中 */
    audioGuide: {
      on: { CLOSE: 'idle' },
    },
    /** 音声ガイド有効範囲外表示中 */
    audioGuideLocked: {
      on: { CLOSE: 'idle' },
    },
  },
})

// ---------------------------------------------------------------------------
// Hook
// ---------------------------------------------------------------------------

export const useSpotDetailAttachedStateMachine = () => {
  const [state, send] = useMachine(spotDetailAttachedMachine)
  return {
    send,
    isArPhotoLocked: state.matches('arPhotoLocked'),
    isAudioGuide: state.matches('audioGuide'),
    isAudioGuideLocked: state.matches('audioGuideLocked'),
  }
}
